const ModesNudge = {
	Create: 'create',
	Update: 'update',
	Republish: 'republish',
	Read: 'read',
};

export { ModesNudge };
